import { gql } from "@apollo/client"

export const getKeeperDevices = gql`
  query getKeeperDevices($keeperId: String) {
    getKeeperDevices(keeperId: $keeperId) {
      current {
        id
        brand
        modelName
        platform
        loginLocation
        loginIp
        lastLoginDate
      }
      others {
        id
        brand
        modelName
        platform
        loginLocation
        loginIp
        lastLoginDate
      }
    }
  }
`
